import BaseService from "./base"

export default class UnityService extends BaseService {
  resource = "/unity"

  constructor(token, baseUrl) {
    super(token, baseUrl)
  }

}
